import React, { useState, useCallback, useMemo, useContext, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Tooltip from '@mui/material/Tooltip';
import EditExportDialog from "./EditExportDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { deleteExport, downloadFile, generateExport } from "../../services/ConfigServices";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "assets/css/customNotifications.css";
import ReactLoading from "react-loading";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BuildIcon from '@mui/icons-material/Build';

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import {
  typeData, recurrenceData, paramTypeDataTemplate, paramTypeDataExport, paramTypeIndicPeriod,
  paramTypeAlertValueData, paramTypeIndicValueData, formatData, periodData, formatDatase60,
  paramTypePatrimoineValueData, paramTypeMapsValueData, paramTypeActionPlanValueData, duplicateData
} from "variables/lists/exports";
import moment from "moment";

const useStyles = makeStyles(styles);

const LoadingDiv = styled.div`
  height: 20vh;
  width: 20vw;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  padding-top: 10vh;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};

const useStyles2 = makeStyles((theme) => ({
  chipfile: {
    maxWidth: "11rem",
  },
}));

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      console.log(response);
      if (response.status == 204) {
        setNotification('error', 'Le rapport a été supprimé de la base documentaire');
      }
      else if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    });
};


const RTExports = () => {
  const appContext = useContext(AdvancedSearchContext);
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const exportscreate = permis.includes("exports_create");
  const { groupInfoListById, setPage } = appContext;
  const {
    gridState,
    error,
    refreshTable,
    permissionList,
    viewList,
    setLoading,
  } = useEntitesTable();

  const [open, setOpen] = useState(false);

  const [id, setId] = useState("");
  const [parameters, setParameters] = useState({});

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();
  const classes2 = useStyles2();

  useEffect(() => {
    setPage('exports');
  }, []);

  const fillButtons = [
    { color: "success", icon: Edit },
    { color: "danger", icon: Close },
  ].map((prop, key) => {
    return (
      <Button
        color={prop.color}
        className={classes.actionButton}
        key={key}
        onClick={prop.onClick}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  let dataExports = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  if (error) {
    return (
      <p>
        <span role="img" aria-label="Problem">
          🔧
        </span>{" "}
        Il semble y avoir une erreur...{" "}
        <button onClick={refreshTable()}>Relancer</button>
      </p>
    );
  }

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.parameters.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Type",
      selector: (row) => row.parameters.type,
      sortable: true,
      minWidth: "10rem",
      cell: (row) => typeData.find(opt => row.parameters.type === opt.id)?.name,
    },
    {
      name: "Format",
      selector: (row) => row.parameters.format,
      sortable: true,
      minWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => formatDatase60.find(opt => row.parameters.format === opt.id)?.name,
    },
    {
      name: "Récurrence",
      selector: (row) => row.parameters.recurrence,
      sortable: true,
      minWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => row.parameters.type === 1 ? recurrenceData.find(opt => row.parameters.recurrence === opt.id)?.name : <></>,
    },
    {
      name: "Diffusion",
      selector: (row) => row.parameters.diffusion,
      sortable: true,
      wrap: true,
      cell: (row) => (
        row.parameters.diffusion ?
          <GroupCell>
            {row.parameters.diffusion?.map((name) => {
              return (
                <div>{name}</div>
              );
            })}
          </GroupCell> : <></>
      ),
    },
    {
      name: "Template",
      selector: (row) => row.parameters.template,
      sortable: true,
      width: "12rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        row.parameters.template ?
          <Chip className={classes2.chipfile} label={row.parameters.template?.fileName} onClick={downloadGED(row.parameters.template?.fileId, row.parameters.template?.fileName)} />
          : <></>
      ),
    },
    {
      name: "Périmètre",
      selector: (row) => row.parameters.groups,
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.parameters.groups]}</div>
          {/* {row.parameters.groups?.map((groupid) => {
            return (
              <div>{groupInfoListById["" + groupid]}</div>
            );
          })} */}
        </GroupCell>
      ),
    },
    {
      name: "Dernier envoi",
      selector: (row) => row.parameters.lastsent,
      sortable: true,
      width: "10rem",
      cell: (row) => row.parameters?.lastsent ? moment(Number(row.parameters.lastsent)).format("DD/MM/YYYY HH:mm") : "",
    },
    {
      name: "Dernier rapport",
      selector: (row) => row.parameters.lastexport,
      sortable: true,
      width: "12rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        row.parameters.generationinprogress === "yes" ?
          <div>Génération en cours</div> :
          row.parameters.generationinprogress === "failed" ?
          <div>La génération a échoué</div> :
          row.parameters.lastexport ?
            <Chip className={classes2.chipfile} label={row.parameters.lastexport?.fileName} onClick={downloadGED(row.parameters.lastexport?.fileId, row.parameters.lastexport?.fileName)} />
            :
            <></>
      ),
    },

    exportscreate ?
      {
        name: "Actions",
        sortable: true,
        width: "10rem",
        // eslint-disable-next-line react/display-name
        cell: (row) => (
          <>
            <div className="actions-right">
              <Tooltip title="Editer">
                <Button
                  color={"success"}
                  className={classes.actionButton}
                  onClick={editExport(row)}
                >
                  <Edit className={classes.icon} />
                </Button>
              </Tooltip>
              <Tooltip title="Supprimer">
                <CustomDeleteButton
                  deleteTitle={"Suppression de l'export"}
                  deleteSubTitle={
                    "Êtes-vous sûr de vouloir supprimer l'export ?"
                  }
                  handleSupprimer={deleteExportSelected(row)}
                />
              </Tooltip>
              <Tooltip title="Générer un rapport maintenant">
                <Button
                  color={"info"}
                  className={classes.actionButton}
                  onClick={generateExportSelected(row)}
                  disabled={row.parameters.generationinprogress === "yes" ? true : false}
                >
                  <BuildIcon className={classes.icon} />
                </Button>
              </Tooltip>
            </div>
          </>
        )
      } : {}
    ,
  ];

  const editExport = (row) => async () => {
    let obj = dataExports.find((o) => o.id === row.id);
    let idSelected = obj.id;

    handleClickOpen();
    setId(obj.id);
    setParameters(obj.parameters);
  };

  const generateExportSelected = (row) => async () => {
    setLoading(true);
    let obj = dataExports.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .put(generateExport(idSelected), {}, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        refreshTable();
      });
  };

  const deleteExportSelected = (row) => async () => {
    setLoading(true);
    let obj = dataExports.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .delete(deleteExport(idSelected), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success("L'export a bien été supprimé");
        else NotificationManager.error("Un problème est survenu");
        refreshTable();
      });
  };

  return (
    <>
      <div style={{ paddingTop: 10 }}>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucun export à afficher</NoData>}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Lignes par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les lignes",
          }}
          progressPending={gridState.loading}
          progressComponent={
            <div>
              <LoadingDiv>
                <ReactLoading
                  type={"bars"}
                  color={"#91c241"}
                  height={"10%"}
                  width={"10%"}
                />
              </LoadingDiv>
            </div>
          }
          {...gridState}
        />

        <Dialog
          onClose={handleClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth={true}
          maxWidth="lg"
          open={open}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Modifier l'export
          </CustomDialogTitle>
          <DialogContent dividers>
            <EditExportDialog
              closeModal={handleClose}
              id={id}
              parameters={parameters}
              setLoading={setLoading}
              setNotification={setNotification}
              refetch={refreshTable}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>

    </>
  );
};

export default RTExports;
